export function CreateApiStore({ state, getters, mutations, actions })  {   
    return {
        namespaced: true,
        state: {
            ...state,
            pendingStateChanges: 0
        },
        getters: {
            ...getters
        },
        mutations: {
            ...mutations,
            setPendingStateChanges(state, val) {
                state.pendingStateChanges += val;
            }
        },
        actions: {
            ...actions
        }
    }
}